// Linked stage shapes follow their map: the runner re-derives them when the map version they follow changes, a whole live snapshot lands (undo/redo, project open, a preset) or shapes relink (`meta.mapLinked`).
import { deriveLinkedShapes } from '~/lib/map/shapes'
import { selectIsRunner, selectProject } from '~/store/app/selectors'
import { selectMaps } from '~/store/maps/selectors'
import { isDesktop } from '~/store/middleware/pinsSync'

const LIVE_RESETS = new Set(['live/setLiveObject', 'live/setObjects', 'live/addObjects'])

// Everything `selectShapeMapData` reads.
const sources = s => [
	s.maps?.editing?.id,
	s.maps?.editing?.draft,
	s.maps?.active_id,
	selectProject(s)?.settings?.map_id,
	selectMaps(s),
]

const mapShapes = store => {
	let last = []
	return next => action => {
		const result = next(action)
		const s = store.getState()
		const now = sources(s)
		const moved = now.some((v, i) => v !== last[i])
		last = now
		const reset = LIVE_RESETS.has(action.type) || action.meta?.mapLinked
		if ((moved || reset) && isDesktop(s) && selectIsRunner(s)) store.dispatch(deriveLinkedShapes())
		return result
	}
}

export default mapShapes
